<template>
  <v-container fluid>
    <v-row justify="center">
      <StatsCard icon="timer-outline" color="amber darken-2" :meter="meterCallers">
        <v-col slot="stats">
          <div class="stats-oncall data">{{ onCall }}</div>
          <div class="label">{{ $t('queues.stats.oncall') }}</div>
        </v-col>
        <v-col slot="stats">
          <div class="stats-waiting data">{{ totalWaiting }}</div>
          <div class="label">{{ $t('queues.stats.waiting') }}</div>
        </v-col>
      </StatsCard>

      <StatsCard icon="phone-in-talk" color="blue darken-4" :meter="meterCalls">
        <v-col slot="stats">
          <div class="stats-completed data">{{ totalCompleted }}</div>
          <div class="label">{{ $t('queues.stats.completed') }}</div>
        </v-col>
        <v-col slot="stats">
          <div class="stats-abandoned data">{{ totalAbandoned }}</div>
          <div class="label">{{ $t('queues.stats.abandoned') }}</div>
        </v-col>
      </StatsCard>

      <StatsCard icon="card-account-phone" color="green darken-3" :meter="meterAgents">
        <v-col slot="stats">
          <div class="stats-agents data">{{ totalAgents }}</div>
          <div class="label">{{ $t('queues.stats.agentsTotal') }}</div>
        </v-col>
        <v-col slot="stats">
          <div class="stats-agents-paused data">{{ agentsPaused }}</div>
          <div class="label">{{ $t('queues.stats.agentsPaused') }}</div>
        </v-col>
        <v-col slot="stats">
          <div class="stats-agents-unpaused data">{{ agentsUnpaused }}</div>
          <div class="label">{{ $t('queues.stats.agentsUnpaused') }}</div>
        </v-col>
      </StatsCard>
    </v-row>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import StatsCard from './stats_card'

export default {
  name: 'queue-top-stats',
  components: { StatsCard },
  computed: {
    ...mapGetters({
      onCall: 'queues/totalActiveCalls',
      totalWaiting: 'queues/totalCallWaiting',
      totalCompleted: 'queues/totalCompletedCalls',
      totalAbandoned: 'queues/totalAbandonedCalls',
      totalAgents: 'queues/totalAgents',
      agentsPaused: 'queues/totalAgentsPaused',
      agentsUnpaused: 'queues/totalAgentsUnpaused'
    }),
    meterCallers: function () {
      const callers = this.onCall + this.totalWaiting
      return ~~(this.totalWaiting / callers * 100)
    },
    meterCalls: function () {
      const calls = this.totalCompleted + this.totalAbandoned
      return ~~(this.totalCompleted / calls * 100)
    },
    meterAgents: function () {
      return ~~(this.agentsUnpaused / this.totalAgents * 100)
    }
  }
}
</script>

<style scoped>
.stats-content .data {font-size: 28px; font-weight: 300}
.stats-content .label { color: #9e9e9e!important; font-size: 12px }
</style>
